/**
 * Re-export shim. The onboarding option config moved to
 * `@dupe/common/onboardingStyles` so the api can read a saved profile back out
 * for the brain's shopper-memory block (DUP-2406) — `apps/api` cannot import
 * from `apps/web`.
 *
 * ⚠️ This path stays because nine web modules import from it. Add new options to
 * the shared module, never here; a local re-declaration would shadow the shared
 * one for web only and the two flows would silently disagree.
 */
export * from '@dupe/common/onboardingStyles'
